export default __webpack_public_path__ + "static/media/Ellipse4@2x.d9e83ddb.png";